import { useRef, useEffect } from "react"
import { Pannellum } from "pannellum-react"
import { io } from "socket.io-client"
import cross from "../FavouritesForm/cross.svg"
import "./Viewer360.css"
import { useStore } from "../ApartmentFinder/State/Store"
// import { useStore } from "components/ApartmentFinder/State/Store"

/* import A4 from "./A/4M.JPG"
import A12 from "./A/12M.JPG"
import A18 from "./A/18M.JPG"
import A25 from "./A/25M.JPG"

import B14 from "./B/14M.JPG"
import B18 from "./B/18M.JPG"
import B24 from "./B/24M.JPG"
import B30 from "./B/30M.JPG"
import B36 from "./B/36M.JPG"

import C6 from "./C/6M.JPG"
import C12 from "./C/12M.JPG"
import C18 from "./C/18M.JPG"
import C24 from "./C/24M.JPG"
import C30 from "./C/30M.JPG"
import C36 from "./C/36M.JPG"
import C42 from "./C/42M.JPG"
import C50 from "./C/50M.JPG"

import D6 from "./D/6M.JPG"
import D12 from "./D/12M.JPG"
import D18 from "./D/18M.JPG"
import D24 from "./D/24M.JPG"
import D30 from "./D/30M.JPG"
import D36 from "./D/36M.JPG"
import D42 from "./D/42M.JPG"
import D70 from "./D/70M.JPG"

import E6 from "./E/6M.JPG"
import E12 from "./E/12M.JPG"
import E18 from "./E/18M.JPG"
import E30 from "./E/30M.JPG" */

const url = process.env.REACT_APP_MARKETING_SUITE
const role = process.env.REACT_APP_ROLE

const Viewer360 = props => {
  const { block, floor, setShow } = props
  let floorFormat

  if (floor.charAt(0) === 0) {
    floorFormat = Number(floor)
  } else {
    floorFormat = floor
  }

  const showRecipient360 = useStore(state => state.showRecipient360)
  const setShowRecipient360 = useStore(state => state.setShowRecipient360)

  const viewer = useRef()
  // const backdropRef = useRef()
  const socket = useRef()

  const lookup = {
    A: {
      0: "A/4M.JPG",
      1: "A/12M.JPG",
      2: "A/12M.JPG",
      3: "A/18M.JPG",
      4: "A/18M.JPG",
      5: "A/25M.JPG",
      6: "A/25M.JPG",
      max: "A/25M.JPG"
    },
    B: {
      0: "B/14M.JPG",
      1: "B/14M.JPG",
      2: "B/14M.JPG",
      3: "B/18M.JPG",
      4: "B/18M.JPG",
      5: "B/18M.JPG",
      6: "B/24M.JPG",
      7: "B/24M.JPG",
      8: "B/24M.JPG",
      9: "B/30M.JPG",
      10: "B/30M.JPG",
      11: "B/36M.JPG",
      12: "B/36M.JPG",
      max: "B/36M.JPG"
    },
    C: {
      0: "C/6M.JPG",
      1: "C/6M.JPG",
      2: "C/12M.JPG",
      3: "C/12M.JPG",
      4: "C/18M.JPG",
      5: "C/18M.JPG",
      6: "C/24M.JPG",
      7: "C/24M.JPG",
      8: "C/30M.JPG",
      9: "C/30M.JPG",
      10: "C/36M.JPG",
      11: "C/36M.JPG",
      12: "C/42M.JPG",
      max: "C/50M.JPG"
    },
    D: {
      0: "D/6M.JPG",
      1: "D/6M.JPG",
      2: "D/12M.JPG",
      3: "D/12M.JPG",
      4: "D/18M.JPG",
      5: "D/18M.JPG",
      6: "D/24M.JPG",
      7: "D/24M.JPG",
      8: "D/30M.JPG",
      9: "D/30M.JPG",
      10: "D/36M.JPG",
      11: "D/36M.JPG",
      12: "D/42M.JPG",
      max: "D/70M.JPG"
    },
    E: {
      0: "E/6M.JPG",
      1: "E/6M.JPG",
      "1 / 2": "E/6M.JPG",
      2: "E/12M.JPG",
      3: "E/12M.JPG",
      4: "E/18M.JPG",
      5: "E/18M.JPG",
      6: "E/30M.JPG",
      max: "E/30M.JPG"
    }
  }

  // const onClick = e => {
  //   if (e.target === backdropRef.current) setShow(false)
  // }

  const moved = () => {
    if (viewer.current && socket.current && role === "sender") {
      socket.current.emit("panorama", [
        viewer.current.getViewer().getPitch(),
        viewer.current.getViewer().getYaw(),
        viewer.current.getViewer().getHfov()
      ])
    }
  }

  useEffect(() => {
    if (url && role) {
      socket.current = io(url)
      if (role === "recipient") {
        socket.current.on("panorama", data => {
          if (viewer.current) {
            viewer.current.getViewer().lookAt(data[0], data[1], data[2])
          }
        })
      }
    }
  }, [])

  const imgUrl = `${process.env.PUBLIC_URL || "/"}assets/360/${
    lookup[block][floorFormat] || lookup[block].max
  }`

  return (
    <div
      style={{
        zIndex: 10000000000,
        pointerEvents: "initial",
        position: "absolute",
        height: "100%",
        width: "100%",
        opacity: role === "recipient" ? (showRecipient360 ? 1 : 0) : 1
      }}
    >
      <Pannellum
        ref={viewer}
        width="100%"
        height="100%"
        image={imgUrl}
        pitch={10}
        yaw={180}
        hfov={110}
        autoLoad
        onRender={() => moved()}
        showZoomCtrl={false}
      />
      <img
        style={{
          margin: "20px",
          cursor: "pointer",
          top: "0%",
          right: "0%",
          position: "absolute",
          zIndex: 20000000000,
          height: "20px",
          width: "20px"
        }}
        src={cross}
        alt="close"
        className="cross"
        onClick={() => setShow(false)}
      />
      {role === "sender" && (
        <img
          alt="views"
          src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/views.svg`}
          style={{
            position: "absolute",
            zIndex: 20000000000,
            bottom: 15,
            left: 15,
            cursor: "pointer",
            opacity: showRecipient360 ? 1 : 0.5,
            transition: ".3s"
          }}
          onClick={() => setShowRecipient360(!showRecipient360)}
        />
      )}
    </div>
    // </div>
  )
}

Viewer360.propTypes = {}

export default Viewer360
